export const REFRESH_TOKEN = 'providers/root/AuthProvider/REFRESH_TOKEN';
export const GET_USER = 'providers/root/AuthProvider/GET_USER';
export const SET_STORE = 'providers/root/AuthProvider/SET_STORE';
export const GET_LICENSE_STATE = 'providers/root/AuthProvider/GET_LICENSE_STATE';
export const GET_LICENSE_STATE_CHANNEL = 'providers/root/AuthProvider/GET_LICENSE_STATE_CHANNEL';
export const CLEAR_LICENSE_STATE_CHANNEL = 'providers/root/AuthProvider/CLEAR_LICENSE_STATE_CHANNEL';
